
import * as dom from './wpstg-dom-utils.js';
import WpstgDirectoryNavigation from './wpstg-directory-navigation.js';
import WpstgTableSelection from './wpstg-table-selection';
import WpstgExcludeFilters from './wpstg-exclude-filters.js';
import WpstgModal from './wpstg-modal.js';
import WPStagingCommon from './../wpstg.js';

/**
 * Manage RESET MODAL
 */
export default class WpstgResetModal {
  constructor(
      cloneID,
      workflowSelector = '#wpstg-workflow',
      fetchExcludeSettingsAction = 'wpstg_clone_excludes_settings',
      modalErrorAction = 'wpstg_modal_error',
      wpstgObject = wpstg,
  ) {
    this.cloneID = cloneID;
    this.workflow = dom.qs(workflowSelector);
    this.wpstgObject = wpstgObject;
    this.fetchExcludeSettingsAction = fetchExcludeSettingsAction;
    this.modalErrorAction = modalErrorAction;
    this.resetButtonClass = 'wpstg-confirm-reset-clone';
    this.resetModalContainerClass = 'wpstg-reset-confirmation';
    this.resetTabSelector = '.wpstg-reset-exclude-tab';
    this.directoryNavigator = null;
    this.excludeFilters = null;
    this.tableSelector = null;
    this.isNetworkClone = false;
  }

  addEvents() {
    const resetModalContainer = dom.qs('.' + this.resetModalContainerClass);
    if (resetModalContainer === null) {
      console.log('Exit');
      return;
    }

    dom.addEvent(resetModalContainer, 'click', this.resetTabSelector, (target) => {
      this.toggleContent(target);
    });
  }

  init() {
    this.addEvents();
  }

  setNetworkClone(isNetworkClone) {
    this.isNetworkClone = isNetworkClone;
  }

  toggleContent(target) {
    const resetModalContainer = dom.qs('.' + this.resetModalContainerClass);
    const contentId = target.getAttribute('data-id');
    const tabTriangle = target.querySelector('.wpstg-tab-triangle');
    const isCollapsed = target.getAttribute('data-collapsed', 'true');
    const content = dom.qs(contentId);
    if (isCollapsed === 'true') {
      if (resetModalContainer.classList.contains('has-collapsible-open')) {
        resetModalContainer.classList.add('has-collapsible-open-2');
      } else {
        resetModalContainer.classList.add('has-collapsible-open');
      }

      dom.slideDown(content);
      tabTriangle.style.transform = 'rotate(90deg)';
      target.setAttribute('data-collapsed', 'false');
    } else {
      if (resetModalContainer.classList.contains('has-collapsible-open-2')) {
        resetModalContainer.classList.remove('has-collapsible-open-2');
      } else {
        resetModalContainer.classList.remove('has-collapsible-open');
      }

      dom.slideUp(content);
      tabTriangle.style.removeProperty('transform');
      target.setAttribute('data-collapsed', 'true');
    }
  }

  /**
   * Show Swal alert with loader and send ajax request to fetch content of alert.
   * @return Promise
   */
  showModal() {
    const swalPromise = this.loadModal();
    this.init();
    this.fetchCloneExcludes();
    return swalPromise;
  }

  loadModal() {
    return WPStagingCommon.getSwalModal(false, {
      confirmButton: this.resetButtonClass + ' wpstg-confirm-reset-clone wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn',
      container: this.resetModalContainerClass + ' wpstg-swal2-container wpstg-swal2-loading',
    }).fire({
      title: '',
      icon: 'warning',
      html: this.getAjaxLoader(),
      width: '400px',
      focusConfirm: false,
      confirmButtonText: this.wpstgObject.i18n.resetClone,
      showCancelButton: true,
    });
  }

  fetchCloneExcludes() {
    this.error = null;
    // send ajax request and fetch preserved exclude settings
    fetch(this.wpstgObject.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams({
        action: this.fetchExcludeSettingsAction,
        accessToken: this.wpstgObject.accessToken,
        nonce: this.wpstgObject.nonce,
        clone: this.cloneID,
        job: 'resetting',
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }

      return Promise.reject(response);
    }).then((data) => {
      if (!data.success) {
        const errorModal = new WpstgModal(this.modalErrorAction, this.wpstgObject);
        errorModal.show(Object.assign({
          title: 'Error',
          icon: 'error',
          html: this.wpstgObject.i18n['somethingWentWrong'],
          width: '500px',
          confirmButtonText: 'Ok',
          showCancelButton: false,
          customClass: {
            confirmButton: 'wpstg--btn--confirm wpstg-blue-primary wpstg-button wpstg-link-btn',
            cancelButton: 'wpstg--btn--cancel wpstg-blue-primary wpstg-link-btn',
            actions: 'wpstg--modal--actions',
            popup: 'wpstg-swal-popup wpstg-centered-modal',
          },
          buttonsStyling: false,
          reverseButtons: true,
        }, data.swalOptions), {
          type: data.type,
        });

        return;
      }

      const modal = dom.qs('.wpstg-reset-confirmation');
      modal.classList.remove('wpstg-swal2-loading');
      modal.querySelector('.wpstg--swal2-popup').style.width = '540px';
      modal.querySelector('.wpstg--swal2-content').innerHTML = data.html;
      this.directoryNavigator = new WpstgDirectoryNavigation('#wpstg-directories-listing', wpstg, null);
      this.directoryNavigator.countSelectedFiles();
      this.excludeFilters = new WpstgExcludeFilters();
      this.tableSelector = new WpstgTableSelection('#wpstg-reset-excluded-tables', '.' + this.resetModalContainerClass);
      this.tableSelector.setNetworkClone(this.isNetworkClone);
      this.tableSelector.countSelectedTables();
    }).catch((error) => {
      this.renderError({
        'html': this.wpstgObject.i18n['somethingWentWrong'] + ' ' + error,
      });
    });
  }

  getDirectoryNavigator() {
    return this.directoryNavigator;
  }

  getExcludeFilters() {
    return this.excludeFilters;
  }

  getTableSelector() {
    return this.tableSelector;
  }

  getAjaxLoader() {
    return '<div class="wpstg-swal2-ajax-loader"><img src="' + this.wpstgObject.wpstgIcon + '" /></div>';
  }
}
